import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Rating from './Rating'
import AddToCart from './AddToCart.jsx';
import { useGetProductReviewsByIdQuery } from '../slices/productsApiSlice.js';

const Product = ({ product }) => {
  const { data: reviews } = useGetProductReviewsByIdQuery(product._id);
  
  return (
    <Card className='p-2 rounded h-100 product-card'>
        <Link to={`/product/${product._id}`}>
            <Card.Img src={product.image} variant='top' className='img-fluid' style={{ objectFit: 'cover' }}/>
        </Link>
        <Card.Body>
            <Link to={`/product/${product._id}`} className='d-block product-title-link'>
                <Card.Text as='div' className='product-title'>
                    <strong>{product.name}</strong>
                </Card.Text>
            </Link>
            <Card.Text as='div' className='product-rating'>
                <Rating
                    value={
                        reviews && reviews.length > 0
                        ? Math.round(
                            (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length) * 10
                            ) / 10
                        : 0
                    }
                    text={
                        reviews && reviews.length > 0
                        ? `(${Math.round(
                            (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length) * 10
                            ) / 10}) - ${reviews.length === 1
                                ? reviews.length + ' review' 
                                : reviews.length  + ' reviews'}`
                        : 'No reviews yet'
                    }
                />
            </Card.Text>
            <Card.Text as='h5' className='product-price'>
                ₹{product.customization.priceCustomization[0].price} / {product.customization.priceCustomization[0].weight}
            </Card.Text>
            <AddToCart product={product} />
        </Card.Body>
    </Card>
  )
}

export default Product